import { useState as classicUseState } from 'react';

import ReactDom from 'react-dom';

import { useState } from '@hookstate/core';

import CloseImage from '@assets/svg/close-ticket.svg';
import { IPaginationResult } from '@models/Equipment.model';
import { IManufacturer } from '@models/Manufacturer.model';
import { IProduct } from '@models/Product.model';
import { WindowButtonImage } from '@pages/Products/components/AddEquipmentModal/components/AddProduct/components/AddProductContent/AddProductContent.styles';
import { EQUIPMENTS_PICKER_SEND_TYPE } from '@store/machines/equipmentsPicker';
import { updateSort } from '@store/redux/features/filter';
import { updateActiveTab } from '@store/redux/features/inventory';
import { useAppDispatch } from '@store/redux/store';
import {
  CloseButton,
  Container,
  Header,
  HeaderBar,
  Overlay,
} from './AddEquipmentModal.styles';
import { FindBody, OnBoardingBody, QuantityBody } from './components';
// import { MassEditAction } from '../OnBoardingModal/helpers/MassEditReducer';

export interface ProductRequest {
  id: string;
  product?: IProduct;
  isTempProduct?: boolean;
  tempProductName?: string;
  manufacturerId?: string;
  quantity: number;
}
interface OwnProps {
  open: boolean;
  onClose: () => void;
  send: EQUIPMENTS_PICKER_SEND_TYPE;
  refreshProducts: any;
}

export const AddEquipmentModal = ({
  open,
  onClose,
  send,
  refreshProducts,
}: OwnProps) => {
  const dispatch = useAppDispatch();
  const portalDiv = document.getElementById('portal');
  const pageState = useState<'find' | 'quantity' | 'onBoarding'>('find');
  const [dataSelected, setDataSelected] = classicUseState<ProductRequest[]>([]);

  const [manufacturer, setManufacturer] = classicUseState<
    IManufacturer | undefined
  >(undefined);
  const [modelNumber, setModelNumber] = classicUseState('');
  const [modelName, setModelName] = classicUseState('');
  const [textManufacturer, setTextManufacturer] = classicUseState('');
  const [page, setPage] = classicUseState(1);
  const [manufacturerArray, setManufacturerArray] = classicUseState<
    IPaginationResult<IManufacturer> | undefined
  >(undefined);
  const [data, setData] = classicUseState<
    IPaginationResult<IProduct> | undefined
  >(undefined);
  const [loadingSearch, setLoadingSearch] = classicUseState(false);

  const updateDataSelected = (productsArray?: ProductRequest[]) => {
    if (!productsArray) return;
    if (productsArray.length === 1) {
      const newProduct = productsArray[0];
      const selected =
        dataSelected.length > 0
          ? dataSelected.find(d => d.id === newProduct.id)
          : undefined;
      if (!selected) {
        setDataSelected(dataSelected.concat([newProduct]));
        return;
      }
      if (selected.quantity !== newProduct.quantity) {
        const newArray = [...dataSelected];
        const index = newArray.indexOf(selected);
        newArray[index] = newProduct;
        setDataSelected(newArray);
      }
    } else {
      const productsNotSelected = productsArray.filter(
        product =>
          dataSelected.find(selected => product.id === selected.id) ===
          undefined,
      );
      if (productsNotSelected.length > 0) {
        setDataSelected([...dataSelected, ...productsNotSelected]);
        return;
      }
      setDataSelected([]);
    }
  };
  const onModalClose = () => {
    dispatch(updateSort(''));
    dispatch(updateActiveTab('equipment'));
    setDataSelected([]);
    pageState.set('find');
    onClose();
  };

  return open && portalDiv
    ? ReactDom.createPortal(
        <Overlay>
          <Container actualPage={pageState.get()}>
            <HeaderBar>
              <Header>
                {pageState.get() === 'onBoarding'
                  ? 'Beam On!'
                  : 'Add Equipment'}
              </Header>
              <CloseButton onClick={onModalClose}>
                <WindowButtonImage src={CloseImage} />
              </CloseButton>
            </HeaderBar>
            {pageState.get() === 'find' && (
              <FindBody
                updateDataSelected={updateDataSelected}
                nextBody={() => {
                  pageState.set('quantity');
                }}
                loadingSearch={loadingSearch}
                setLoadingSearch={setLoadingSearch}
                data={data}
                setData={setData}
                manufacturerArray={manufacturerArray}
                setManufacturerArray={setManufacturerArray}
                page={page}
                setPage={setPage}
                setTextManufacturer={setTextManufacturer}
                textManufacturer={textManufacturer}
                setModelName={setModelName}
                modelName={modelName}
                setModelNumber={setModelNumber}
                modelNumber={modelNumber}
                setManufacturer={setManufacturer}
                manufacturer={manufacturer}
              />
            )}
            {pageState.get() === 'quantity' && (
              <QuantityBody
                products={dataSelected}
                returnBody={() => {
                  pageState.set('find');
                }}
                nextBody={() => {
                  pageState.set('onBoarding');
                }}
                onClose={onModalClose}
                send={send}
                updateDataSelected={updateDataSelected}
                refreshProducts={refreshProducts}
              />
            )}
            {pageState.get() === 'onBoarding' && (
              <OnBoardingBody send={send} onClose={onModalClose} />
            )}
          </Container>
        </Overlay>,
        portalDiv,
      )
    : null;
};
